// extracted by mini-css-extract-plugin
export default {"marginTop":"AdmissionDetails_marginTop__rf1Uj","formTitle":"AdmissionDetails_formTitle__GkzoE"};